import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Hero from './hero';
import SectionMilestone from './section-milestone';
import SectionTab from './section-tab';
import { useQuery, gql } from '@apollo/client';
// const FUND_BY_ID = gql`
//   query GetFund($slug: String!) {
//     funds(filters: { slug: { eq: $slug } }) {
//       data {
//         id
//         attributes {
//           title
//           }
//       }
//     }
//   }
// `

const FUND_BY_ID = gql`
  query GetFund($slug: String!) {
    funds(filters: { slug: { eq: $slug } }) {
      data {
        id
        attributes {
          title
          body
          hero {
            data {
              id
              attributes {
                url
                alternativeText
                caption
                width
                height
                createdAt
                updatedAt
              }
            }
          }
          icon {
            data {
              id
              attributes {
                url
                alternativeText
                caption
                width
                height
                createdAt
                updatedAt
              }
            }
          }
          Milestone{
            id
            LeftText
            RightText
          }
          Tabs {
            __typename
            ... on ComponentTeamTeam {
              Members (pagination: { limit: -1 }){
                id
                fullname
                role
                linkedin
                body
                picture {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
            __typename
            ... on ComponentPowerbiPowerbi {
              title
              source
              tab_name
            }
            __typename
            ... on ComponentInfoInfo {
              LeftSide {
                title
                data
              }
              RightSide {
                title
                subtitle
              }
              tab_name
            }
            __typename
            ... on ComponentActivesActives {
              tab_name
              properties {
                id
                title
                body
                subtitle
                thumbnail {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
            __typename
            ... on ComponentCategoryCategory {
              tab_name
              archive {
                data {
                  id
                  attributes {
                    Documents (pagination: { limit: 100 }){
                      id
                      title
                      Files (pagination: { limit: -1 }){
                        id
                        name
                        pdf {
                          data {
                            id
                            attributes {
                              url
                              size
                              updatedAt
                              createdAt
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          display_fund_btn{
            display
            title
            url
          }
          createdAt
          updatedAt
          publishedAt
        }
      }
    }
  }
`

const Fund = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(FUND_BY_ID, {
    variables: { slug: id }
  });

  if(error){
    console.log('InvestmentItem: ', error);
  };

  if(loading){
    return <p>Cargando Fund...</p>
  }

  return (
    <>
      <Header background={"c-header--white"}/>
      <Hero props={data}/>
      <SectionMilestone props={data?.funds?.data[0]?.attributes?.Milestone}/>
      <SectionTab props={data}/>
      <Footer/>
    </>
  )
}

export default Fund